import { __assign } from "tslib";
import { EntityConfig } from "./EntityConfig";
import { FieldConfig } from "./FieldConfig";
import { Base } from "./Base";
export function Field(fieldConfig) {
    if (fieldConfig === void 0) { fieldConfig = {}; }
    return function (proto, property) {
        var entityConfig = EntityConfig.forPrototype(proto);
        var name = property.toString();
        var entity;
        var reflectedEntity;
        if ("getMetadata" in Reflect) {
            entity = Reflect.getMetadata("design:type", proto, property);
            if (entity) {
                reflectedEntity = entity;
            }
            if (!entity || !(entity.prototype instanceof Base)) {
                entity = undefined;
            }
        }
        if ("entity" in fieldConfig && fieldConfig.entity === undefined) {
            throw new TypeError("Designed: Entity.Field({ entity }) was set to undefined. This may indicate a circular dependency has been introduced.");
        }
        entityConfig.addField(new FieldConfig(__assign(__assign(__assign(__assign({}, (reflectedEntity && { reflectedEntity: reflectedEntity })), (entity && { entity: entity })), fieldConfig), { name: name })));
    };
}
